import {Component, ViewChild, HostListener, ElementRef} from "@angular/core";
import {Myact} from "../../../../models";
import {Filter, HttpService, FilterContracts} from "../../../../services";
import {BsModalComponent} from "ng2-bs3-modal/ng2-bs3-modal";
import {PagerService} from "../../../../services/index";
import {StringUtility} from "../../../../util/string.utility";
import {AgentUtility} from "../../../../util/agent.utility";
import {Router, ActivatedRoute, Params} from "@angular/router";
import {MyactsService} from "../../../../services/myacts.service";
import {ResponseApi} from "../../../../services/response/response";
import { FormBuilder, FormGroup, FormArray, FormControl, ReactiveFormsModule, NgForm, FormsModule} from '@angular/forms';
import {Agent, Contract, Event, EventFilterDate, EventTypes, Product, StatusContract} from "../../../../models";
import {TreeUtil} from "../../../../util/tree";
import {retry} from "rxjs/operator/retry";
import {ContractsService} from "../../../../services/contracts.service";
import {AgentsService} from "../../../../services/agents.service";
import {EventFilter, EventsService} from "../../../../services/events.service";
import {AppSettings} from "../../../../app.settings";



@Component({
    moduleId: module.id,
    selector: 'agent_reports',
    templateUrl: 'agent_reports.component.html',   
    styleUrls: ['agent_reports.component.css'],
    providers: [MyactsService, PagerService, EventsService]
})
export class AgentReportsComponent {
    acts: Myact[] = [];
    showLoadScreen: boolean = false;
    showParameters: Boolean = false;
    printAct: any = [];
    rowNum: number;    

    pager: any = {};
    pagedItems: any[];
    pageSize: number = 20;
    totalItems: number;

    constructor(private myactsService: MyactsService, private pagerService: PagerService, private eRef: ElementRef, private router: Router, private formBuilder: FormBuilder) {
        this.myactsService.onStart = () => this.showLoadScreen = true;
        this.myactsService.onEnd = () => this.showLoadScreen = false;
    }
    
    ngOnInit() {
       var id = AgentUtility.getUser().Id;
       this.myactsService.getActsByAgentId(id).subscribe((data) => { this.acts = data.data;});
    }   

    public onPostForActUID(id, row_no){
            this.rowNum = 0;
            this.myactsService.checkExistAct(id).subscribe(data => {this.printAct = data;if(this.printAct.status == 'OK')
            {
                var win = window.open(AppSettings.apiUrl + 'acts/getAct/' + id, '_blank');
            }
            else
            {              
                this.rowNum = row_no + 1;
            }});            
    }

    public formatPayDay(payDay:string):string{
        return payDay? payDay.split(";").join('\n') : null;
    }
}
